// import React, { useState } from "react";
// import Navbar from "./components/navbar/Navbar";
// import HeroSection from "./components/herosection/HeroSection";
// import About from "./components/about/About";
// // import Projects from "./components/projects/Projects";
// // import Contact from "./components/contact/Contact";
// import { getPortfolioData } from "./data/portfolioData";
// import "./App.css";

// function App() {
//   const data = getPortfolioData();
//   console.log("Portfolio Data", data)
//   const [activeSection, setActiveSection] = useState("hero"); // default section

//   return (
//     <div className="portfolio-template">
//       <Navbar setActiveSection={setActiveSection} />

//       {activeSection === "hero" && <HeroSection />}
//       {activeSection === "about" && <About />}
//       {/* {activeSection === "projects" && <Projects />} */}
//       {/* {activeSection === "contact" && <Contact />} */}
//     </div>
//   );
// }

// export default App;


import React, { useState, useEffect } from "react";
import Navbar from "./components/navbar/Navbar";
import HeroSection from "./components/herosection/HeroSection";
import About from "./components/about/About";
import Service from "./components/service/Service";
import Projects from "./components/projects/Projects";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer"; 
import { getPortfolioData } from "./data/portfolioData";
import Loader from "./components/loader/Loader";
import "./App.css";
import Resume from "./components/resume/Resume";

function App() {
  const data = getPortfolioData();
  const [activeSection, setActiveSection] = useState("hero"); // default section
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000); // 2 seconds loading
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="portfolio-template">
      <Navbar setActiveSection={setActiveSection} />

      {activeSection === "hero" && <HeroSection setActiveSection={setActiveSection}/>}
      {activeSection === "about" && <About />}
      {activeSection === "resume" && <Resume />}
      {activeSection === "services" && <Service />}
      {activeSection === "projects" && <Projects />}
      {activeSection === "contact" && <Contact />}
       <Footer />
    </div>
  );
}

export default App;

